import { Card, Col, Form } from "antd";

import TableProduct from "./components/Table";
import { TitleCard } from "./components/TitleCard";
import "./index.scss";
import { useOrderPromo } from "./useOrderPromo";

export const OrderPromoForm = ({ form, isUpdate, dataTiersServer, promotionCampaignID }) => {
  const { dataTableProduct, handleDeleteProduct, handleKeyPress, handleAddItem, handleCopyItem } = useOrderPromo({
    form,
    isUpdate,
    dataTiersServer,
    promotionCampaignID,
  });

  return (
    <div className="order-promo-form">
      <Card title={<TitleCard title="THÔNG TIN KHUYẾN MÃI" />}>
        <Col span={24}>
          <Form.List name="promoOrderItems">
            {(items, { add, remove }) => {
              return (
                <div>
                  <TableProduct
                    onAdd={handleAddItem}
                    onCopy={handleCopyItem}
                    remove={remove}
                    form={form}
                    dataTableProduct={dataTableProduct}
                    handleDeleteProduct={handleDeleteProduct}
                    handleKeyPress={handleKeyPress}
                  />
                </div>
              );
            }}
          </Form.List>
        </Col>
      </Card>
    </div>
  );
};
